var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isClient &&
    (_vm.viqOverride || (_vm.hasSomeAccess && !_vm.shouldBlockViq))
    ? _c("div", [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "pickaxe-wrapper" } }, [
      _c("div", { attrs: { id: "pickaxe-container" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }